<template>
    <div>
        <header class="form-title">
            <Row>
                <Col span="18">
                    <Form  inline  :label-width="80" >
                        <FormItem label="调拨人：">
                            <strong>{{formdata.admin}}</strong>
                        </FormItem>
                        <FormItem label="合计：">
                            <strong>{{formSelect.total}} 件</strong>
                        </FormItem>
                        <FormItem label="调拨类型">
                            <Select v-model="formdata.isAccess" class="formSelect-input" style="width: 100px" >
                                <Option value="0">调入</Option>
                                <Option value="1">调出</Option>
                            </Select>
                        </FormItem>

                        <FormItem :label="shopname2">
                            <Input v-model="formdata.shopName"  class="formSelect-input"  disabled  style="width: 150px"  />
                        </FormItem>
                        <FormItem :label="shopname1">
                            <Select class="formSelect-input" style="width: 150px" v-model="formdata.out" >
                                <Option  :value="k.id" v-for="(k,v) in formdata.shopList" :key="v">{{k.name}}</Option>
                            </Select>
                        </FormItem>
                    </Form>
                </Col>
                <Col span="6" align="right"><Button type="primary" style="position: relative;top: -10px;" @click="commodityModal=true"><Icon type="md-add" /></Button></Col>
            </Row>
        </header>
        <Alert v-if="afterSelection.length==0" align="center">添加数据</Alert>
        <Collapse v-model="opensTable"  v-if="afterSelection.length!=0">
            <Panel  :name="index+''"  v-for="(item,index) in afterSelection" :key="index">
                <span>{{ item.name }} ({{item.goodscode}})</span>
                <table slot="content" class="ive-table">
                    <thead>
                    <th>商品图</th>
                    <th>规格</th>
                    <th>颜色</th>
                    <th>本店数量</th>
                    <th>调拨数量</th>
                    <th>操作</th>
                    </thead>
                    <tbody>
                    <tr align="center"  v-for="(k,v) in item.sItems">
                        <td :rowspan="item.sItems.length" v-if="v==0" width="240">
                            <Fy-Img
                                    :ImgSrc="item.goodsimg | filtImg(item.goodsimg)"
                                    :Width="100"
                                    :Height="100"
                            ></Fy-Img>
                        </td>
                        <td>{{k.size}}</td>
                        <td>{{k.color}}</td>
                        <td>{{k.num}}</td>
                        <td>{{k.nums}}</td>
                        <td  :rowspan="item.sItems.length" v-if="v==0" width="200">
                            <ButtonGroup shape="circle">
                                <Button type="primary" icon="md-create" title="编辑" @click="editSendData(item)"></Button>
                                <Button type="warning" icon="md-trash" title="删除" @click="delSendData(item,index)"></Button>
                            </ButtonGroup>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </Panel>
        </Collapse >
        <Row v-if="afterSelection.length!=0" style="margin-top: 30px">
            <Col span="24">
                <Input  type="textarea" v-model="formdata.remark" :autosize="{minRows: 3,maxRows:30}" :maxlength="100" placeholder="备注（最多输入100个字符）"></Input>
            </Col>
            <Col span="24" align="right">
                <Button type="primary" style="margin-top: 15px" :loading="loadingOpeningOrder" @click="openingOrder()">
                    <span v-if="!loadingOpeningOrder">调拨开单</span>
                    <span v-else>提交中</span>
                </Button>
            </Col>
        </Row>
        <!--选择商品-->
        <Modal
                width="90%"
                v-model="commodityModal"
                title="选择添加的商品">
            <Form  inline>
                <FormItem>
                    <Input type="text"  v-model="searchNeirong" placeholder="请输入商品名、货号">
                    </Input>
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="getGoodsList()">确定</Button>
                </FormItem>
            </Form>
            <div class="demo-split">
                <Split v-model="split">
                    <div slot="left" class="demo-split-pane">
                        <table slot="content" class="ive-table">
                            <thead>
                            <th>选择</th>
                            <th width="100">图片</th>
                            <th width="180">名称</th>
                            <th>货号</th>
                            <th>库存</th>
                            <th>售价</th>
                            <th>已选</th>
                            </thead>
                            <tbody>
                            <tr align="center" v-for="(item, index) in goodsListL" :key="index" style="cursor: pointer" @click="setDataListFn(goodsListL,index)">
                                <td width="80">
                                    <RadioGroup v-model="resultItem.single">
                                        <Radio :label="item.id">{{index+1}}</Radio>
                                    </RadioGroup>
                                </td>
                                <td> <div class="imgbox">
                                    <Fy-Img
                                            class="img"
                                            :ImgSrc="item.goodsimg | filtImg(item.goodsimg)"
                                            :Width="50"
                                            :Height="50">
                                    </Fy-Img>
                                    <span v-if="item.tagCode!=null">总</span>
                                </div></td>
                                <td>{{item.name}}</td>
                                <td >{{item.goodscode}}</td>
                                <td>{{item.num}}</td>
                                <td >{{item.lprice}}</td>
                                <td  v-if="item.nums>0" style="color: #ff9900">{{item.nums}}</td>
                                <td  v-else>{{item.nums}}</td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="pageTotal">
                            <Page  :total="page.total"
                                   show-total
                                   :page-size="page.rows"
                                   @on-change="onChange" />
                        </div>
                    </div>
                    <div slot="right" class="demo-split-pane">
                        <div class="commodityMsg">
                            <span  class="img" v-if="resultItem.goodsimg==''">暂无商品图片</span>
                            <Fy-Img
                                    class="img"
                                    :ImgSrc="resultItem.goodsimg"
                                    :Width="80"
                                    :Height="80"
                            ></Fy-Img>
                            <h2>{{resultItem.name}} </h2>
                            <h3>售价: <span class="money"> ￥{{resultItem.price}}</span></h3>
                            <h3>库存:<span  class="num"> {{resultItem.num}}</span></h3>
                        </div>
                        <div style="max-height: 400px;overflow: auto" class="overflowRightNav">
                            <div class="commodityClolr">
                                <h3>选择颜色</h3>
                                <span class="tag"
                                      v-for="(m,n) in resultItem.colors"
                                      :key="n" :class="{isSelectClass:selectColorGroup.isCheckable==n}"
                                      @click="setColorsFn(goodsListL,selectColorGroup.index,n)" >
                              {{m.color}}
                          </span>
                            </div>
                            <div class="commoditymiss">
                                <!-- <h3>选择规格</h3>-->
                                <table>
                                    <tr>
                                        <th>库存</th>
                                        <th>规格</th>
                                        <th>颜色</th>

                                        <th>
                                            当前库存量
                                        </th>
                                    </tr>
                                    <tr v-for="(item, index) in resultItem.goodsItem">
                                        <td>{{item.num}}</td>
                                        <td>{{item.size}}</td>
                                        <td>{{item.color}}</td>

                                        <td><InputNumber :min="0" size="small" v-model="item.nums"  @on-change="setMoneyall"></InputNumber></td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div class="Total">
                            <h3>
                                <Row>
                                    <Col span="24">共:{{summary.totalPieces}}件</Col>
                                </Row>
                            </h3>
                        </div>
                    </div>
                </Split>
            </div>
            <div slot="footer">
                <Button type="text" @click="commodityModal=false">取消</Button>
                <Button type="primary" @click="addsSelectItem('true')">确定</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    import FyImg from "../../components/Common/FyImg";
    export default {
        components: {FyImg},
        data() {
            return {
                cid:'',
                sid:'',
                shopname1:'调出店面',
                shopname2:'调入店面',
                shopId:JSON.parse(localStorage.getItem('shop')).id,//本店铺id
                formdata:{//头信息
                    admin :JSON.parse(localStorage.getItem('adminUser')).name,
                    isAccess:'0',
                    shopList:[],
                    out:'',
                    shopName:JSON.parse(localStorage.getItem('shop')).name, //当前店面
                    remark:"",
                },
                opensTable:'0',//展开那一个
                loadingOpeningOrder:false,
                formSelect:{
                    total:0,//总件数
                    alljfNum:0,//
                },
                currentPageData:[],//当前页所选的数据
                afterSelection:[],//发送的数据
                searchNeirong:"",
                resultItem:{//默认显示详情
                    single:null,
                    img:'',
                    name:'',
                    price:'',
                    num:'',
                    colors:[],
                    sizes:[],
                    goodsItem:[]
                },
                resultNum:0,
                selectData:{
                    all:0,
                },
                //总件
                summary:{
                    totalPieces:0,

                },
                //记录数选择数值
                selectColorGroup:{
                    isCheckable:0,
                    index:0
                },
                goodsListL:[],
                commodityModal:true,
                split: 0.7,
                page:{
                    total:1,
                    page:1,
                    rows:8,
                },
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.getGoodsList(this.cid,this.sid)
            this.getShopList()
        },
        watch: {
            'formdata.isAccess': {
                deep: true,
                handler: function (newVal,oldVal){
                    if(newVal==0){
                        this.shopname1='调出店面'
                        this.shopname2='调入店面'
                    }else {
                        this.shopname2='调出店面'
                        this.shopname1='调入店面'
                    }
                }
            },
            'searchNeirong': {
                deep: true,
                handler: function (newVal,oldVal){
                    this.getGoodsList()
                }
            }
        },

        methods: {
           //店面列表
            getShopList() {
                var data = {
                    cid: this.cid,
                    page: 1,
                    rows: 1000
                };
                this.$Api.getShopList(data).then(res => {
                    this.formdata.shopList = res.data;
                    this.formdata.out = res.data[0].id;
                });
            },
            //获取所有商品列表
            getGoodsList(){
                this.$Api.getListByGoodsnameOrGoodscode({
                    cid: this.cid,
                    sid: this.sid,
                    page: this.page.page,
                    rows: this.page.rows,
                    condition:this.searchNeirong,//查询内容
                }).then(res => {
                    if(res.code==200){
                        this.page.total = res.count
                        this.goodsListL = res.data
                        this.setDataListFn(this.goodsListL,0)
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            setDataListFn(getData,i){
                this.resultItem.single = getData[i].id;
                this.resultItem.goodsimg = getData[i].goodsimg;
                this.resultItem.name = getData[i].name;
                this.resultItem.price = getData[i].lprice;
                this.resultItem.num = getData[i].num;
                this.resultItem.colors =getData[i].colors;
                this.selectColorGroup.index=i


                var sessgools = JSON.parse(sessionStorage.getItem('gools'))
                if(sessgools!=null){
                    sessgools.forEach((item,index)=>{
                        this.goodsListL.forEach((m,n)=>{
                            if(item.id==m.id){
                                this.goodsListL[n]=sessgools[index]
                            }
                        })

                    })
                }

                this.setMoneyall()
                this.setColorsFn(getData,i,0)
            },
            //选择的颜色
            setColorsFn(getData,i,n){
                this.selectData.all=0
                this.resultNum=0
                this.selectColorGroup.isCheckable=n
                var resultColor = getData[i].colors[n].color
                var resultGoodsItem = getData[i].goodsItem
                this.resultItem.goodsItem=[]
                resultGoodsItem.forEach((k,v)=> {
                    if(resultGoodsItem[v].color==resultColor){
                        this.resultItem.goodsItem.push(k)
                    }
                })
            },
            setMoneyall(){

                /** 计算当前向的总件数和总金额 **/
                var allPieces=0
                var checks=0

                this.goodsListL[this.selectColorGroup.index].goodsItem.forEach((value,index)=>{
                    checks=checks+value.nums
                    allPieces=allPieces+this.goodsListL[this.selectColorGroup.index].goodsItem[index].nums
                })

                //计算所选的总数
                this.goodsListL[this.selectColorGroup.index].nums=checks

                if(checks==0){
                    var sessgools = JSON.parse(sessionStorage.getItem('gools'))

                    var goodID = this.goodsListL[this.selectColorGroup.index]
                    if(sessgools!=null){
                        sessgools.forEach((item,index)=>{
                            if(item.id==goodID.id){
                                sessgools.splice(index,1);
                            }
                        })
                        this.currentPageData.forEach((item,index)=>{
                            if(item.id==goodID.id){
                                this.currentPageData.splice(index,1);
                            }
                        })
                        sessionStorage.setItem('gools',JSON.stringify(sessgools))
                    }
                }

                //总件数
                this.summary.totalPieces=allPieces
                //总金额
                this.summary.totalMoney=allPieces*this.resultItem.price
                this.selectDataSingle()
            },

            //设置缓存所选择的项
            selectDataSingle(){
                /** 储存当前页的所选数据 **/
                var listArray=null
                for(var i=0;i<this.goodsListL[this.selectColorGroup.index].goodsItem.length;i++) {
                    if(this.goodsListL[this.selectColorGroup.index].goodsItem[i].nums!=0){
                        listArray = this.goodsListL[this.selectColorGroup.index]
                        break
                    }
                }
                if(listArray!=null){
                    if( this.currentPageData==''){
                        this.currentPageData.push(listArray)
                    }else {
                        var flags=true
                        for (var i=0; i<this.currentPageData.length; i++) {
                            if(this.currentPageData[i].id==listArray.id){
                                this.currentPageData[i]=listArray
                                flags=false
                                break;
                            }
                        }
                        if(flags){
                            this.currentPageData.push(listArray)
                        }
                    }
                    sessionStorage.setItem('gools',JSON.stringify(this.currentPageData))
                }

            },


            //添加按钮
            addsSelectItem(str){
                var getGools = JSON.parse(sessionStorage.getItem('gools'))
                this.afterSelection=[]
                var listArray1=[]
                getGools.forEach((item,index)=>{
                    var itemArray=[];
                    item.goodsItem.forEach((m,v)=>{
                        if(m.nums!=0){
                            m.lprice=item.lprice
                            m.nownum= item.num
                            m.checknum=m.nums
                            itemArray.push(m)
                        }
                    })
                    if(itemArray !=''){
                            item.goodsid=item.id,
                            item.sItems=itemArray,
                            listArray1.push(item)
                            itemArray=[]

                    }
                })
                if(this.afterSelection==''){
                    this.afterSelection=listArray1
                }else {
                    listArray1.forEach((item, index)=>{
                        if( this.afterSelection.indexOf(item)==-1){
                            this.afterSelection.splice(index,1,item)
                        }else {
                            this.afterSelection.push(item)
                        }
                    })
                }
                if(str=='true'){
                    this.commodityModal=false
                }
                this.formSelect.total=0
                this.afterSelection.forEach( (item,index)=>{
                    item.goodsItem.forEach((m,n)=>{
                        this.formSelect.total+= m.nums
                    })
                })
            },
            //重新编辑
            editSendData(data){
                this.commodityModal=true
                let i=0
                this.goodsListL.forEach((item,index)=>{
                    if(data.id==item.id){
                        i = index
                    }
                })
                this.setDataListFn(this.goodsListL,i)
            },

            //删除
            delSendData(k,index){
                var sessgools = JSON.parse(sessionStorage.getItem('gools'))
                if(sessgools!=null){
                    sessgools.forEach((item,index)=>{
                        if(k.id==item.id){
                            sessgools.splice(index,1);
                        }
                    })
                    sessionStorage.setItem('gools',JSON.stringify(sessgools))
                }

                this.afterSelection.splice(index,1)
                this.goodsListL.forEach((item,index)=>{
                    if(k.id==item.id){
                        item.goodsItem.forEach((m,n)=>{
                            m.nums=0
                        })
                    }
                })

                this.formSelect.total=0
                this.afterSelection.forEach( (item,index)=>{
                    item.goodsItem.forEach((m,n)=>{
                        this.formSelect.total+= m.nums
                    })
                })

            },

            //修改分页
            onChange(e){
                this.page.page=e
                this.searchNeirong=''
                this.getGoodsList(this.cid,this.sid)
                this.addsSelectItem()
            },
            /**
             * 开单
             * */
            openingOrder(){

                var array=[]
                this.afterSelection.forEach((item,index)=>{
                    var itemArray=[];
                    item.goodsItem.forEach((m,v)=>{
                        if(m.nums!=0){
                            itemArray.push({
                                colorid: m.colorid,
                                goodsid: m.goodsid,
                                quantity: m.checknum,
                                sizeid: m.sizeid
                            })
                        }

                    })

                    var obj={}
                    obj.goodscode=item.goodscode
                    obj.goodsname=item.name
                    obj.goodsid=item.goodsid
                    obj.goodsimg=item.goodsimg
                    obj.itmes=itemArray
                    array.push(obj)

                })
                var comeid=''
                var enterid=''
                if(this.formdata.isAccess==0){
                    comeid=this.shopId
                    enterid=this.formdata.out
                }else {
                    enterid=this.shopId
                    comeid=this.formdata.out
                }
                if(comeid==enterid){
                    this.$Message.warning('相同店面，不可操作');
                    return;
                }
                this.loadingOpeningOrder=true
                this.$Api.addInventory({
                    adminid: JSON.parse(localStorage.getItem('adminUser')).id,
                    cid:this.cid,
                    quantity: this.formSelect.total,
                    remark: this.formdata.remark,
                    sid: this.sid,
                    type:this.formdata.isAccess,
                    comeid: comeid,//调入
                    comeids:comeid,
                    enterid: enterid,//调出
                    goods:  array ,

                }).then(res => {
                    if(res.code==200){
                        this.$router.push({
                            path:'/allocahisdetail',
                            query:{
                                id:res.data
                            }
                        })
                        this.$Message.success('调拨成功');
                    }else {
                        this.$Message.warning(res.msg);
                    }
                    sessionStorage.removeItem('gools');
                    this.loadingOpeningOrder=false
                }).catch( (err)=> {
                    this.loadingOpeningOrder=false
                })
            },


        }
    };
</script>

<style lang="scss" scoped>
    .form-title{

        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }
    .ive-table{
        width: 100%;
        border-collapse: collapse;
        th{
            background: #bfdeff;
            padding: 10px;
        }
        tr td{
            border: 1px solid #ececec;
            padding: 5px;
        }
    }
    .demo-split{
        height: 600px;
        border: 1px solid #dcdee2;
    }
    .demo-split-pane{
        padding: 20px ;
        position: relative;
        height: 598px;
    }
    .commodityMsg{
        position: relative;
        padding-left: 105px;
        margin-top: 10px;
        height: 110px;
        .img{
            position: absolute;
            left: 15px;
            top: 0;
        }
        h3{
            padding-top: 5px;
        }
        .money{
            color: rgba(255, 148, 94, 1);
        }
        .num{
            color: rgba(84, 169, 119, 1);
        }
    }
    .commodityClolr{
        padding: 20px 0;
        h3{
            padding: 5px 0 5px 0;
        }
        .tag{
            display: inline-block;
            padding: 4px 8px;
            border: 1px solid #e8eaec;
            color: #515a6e;
            border-radius: 3px;

            cursor: pointer;
            margin: 5px 5px 0 0;
        }
    }
    .commoditymiss{
        h3{
            margin: 20px 0 10px;
        }
        table{
            width: 100%;
            text-align: center;
            tr{
                td{
                    padding-top: 10px;
                }

            }
        }
    }
    .Total{
        width: 100%;
        position: absolute;
        right: 0;
        bottom: 0;
        text-align: center;
        padding: 15px;
        background: #dcdee2;
        color:#ff9900
    }
    .formSelect-input{
        width: 180px;
    }

    .isSelectClass{
        background: #ff9800;
        color: #ffffff!important;
    }
    .msg{
        display: inline-block;
        margin-bottom: 20px;
        strong{
            color: #ff7f7f;
        }

    }
</style>